export default __webpack_public_path__ + "static/media/Comp 2_00036.a5016db6.png";